(function (upp) {
    'use strict';

    upp.controller('upp.points.PointsCtrl', ['$scope', 'appi','pointsService','$window',
        function ($scope, appi, pointsService, $window) {

            appi.ui.changeActualOption({moduleKey2Display: 'points', navbarKey: 'pointscard'});
            appi.ui.showPageLoadingMsg();

            $scope.points = "";
            $scope.disabled = true;

            $scope.sections = {
                main: 'main',
                tos: 'tos'
            };

            $scope.section = $scope.sections.main;
            /**
             * Getting Points Programs
             */
            pointsService.getPointsCard ()
                .then(function (points) {
                    $scope.points = points;
                    appi.ui.hidePageLoadingMsg();
                });
            /**
             * Getting User's current points
             */
            appi.security.getAuthentication().then(function(auth) {
                if (auth.type == 'anonymous') {
                    $scope.current = 0;

                } else {
                    pointsService.getUserPoints().then(function(userPoints) {
                        $scope.current = userPoints.current;
                    });
                }
            });

            /**
             * Show Main Div
             *
             */
            $scope.showMainWindow = function () {
                $scope.section = $scope.sections.main;
            };
            /**
             * Show Redeem Div
             *
             */
            $scope.showRedeem = function(prizeId){
                $window.location.href = "#!/pointscard/points-redeem/" + prizeId;
            }
            /**
             * Show Asign Div
             *
             */
            $scope.showAssign = function(){
                $window.location.href = "#!/pointscard/points-assign"
            }
            /**
             * Show Conditions Div
             *
             */
            $scope.showConditionsWindow = function () {
                $scope.section = $scope.sections.tos;
            };

        }
    ]);
})(upp);



// WEBPACK FOOTER //
// ./src/app/modules/points/controllers/points-controller.js